import { useState } from "react";
import { Button, Form, Container, Card, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const handleLogin = () => {
        console.log("Email:", email, "Password:", password);
    };

    const handleGoogleLogin = () => {
        console.log("Iniciando sesión con Google");
    };

    const handleFacebookLogin = () => {
        console.log("Iniciando sesión con Facebook");
    };

    return (
        <Container className="d-flex justify-content-center align-items-center local-hire-design" style={{ minHeight: '100vh' }}>
            <Card className="p-4 shadow-lg border-0 rounded-lg" style={{ maxWidth: '400px', width: '100%' }}>
                <Card.Body>
                    <h2 className="text-center mb-4 text-primary fw-bold font-montserrat">Iniciar sesión</h2>

                    <Row className="mb-3">
                        <Col>
                            <Button
                                variant="outline-danger"
                                className="w-100 mb-2 rounded-pill shadow-sm"
                                onClick={handleGoogleLogin}
                            >
                                <i className="bi bi-google me-2"></i>
                                Iniciar sesión con Google
                            </Button>

                            <Button
                                variant="outline-primary"
                                className="w-100 rounded-pill shadow-sm"
                                onClick={handleFacebookLogin}
                            >
                                <i className="bi bi-facebook me-2"></i>
                                Iniciar sesión con Facebook
                            </Button>
                        </Col>
                    </Row>

                    <div className="text-center text-muted my-3">o usa tu correo</div>

                    <Form>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label className="fw-medium">Correo electrónico</Form.Label>
                            <Form.Control
                                type="email"
                                placeholder="Ingresa tu correo"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="rounded-pill shadow-sm"
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label className="fw-medium">Contraseña</Form.Label>
                            <Form.Control
                                type="password"
                                placeholder="Ingresa tu contraseña"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="rounded-pill shadow-sm"
                            />
                        </Form.Group>

                        <Button variant="primary" type="button" onClick={handleLogin} className="w-100 rounded-pill shadow-sm">
                            Iniciar sesión
                        </Button>
                    </Form>

                    <div className="text-center mt-3">
                        <small className="text-muted">
                            ¿No tienes una cuenta? <Link to="/register" className="text-primary fw-bold">Regístrate</Link>
                        </small>
                    </div>
                </Card.Body>
            </Card>
        </Container>
    );
}

export default Login;
